
import { XhrClient } from "../packages/http";
import {
  POST,
  GET,
  PUT,
  HEAD,
  CONTENT_TYPE_TEXT_HTML,
  CONTENT_TYPE_TEXT_PLAIN,
  CONTENT_TYPE_TEXT_JSON,
  CONTENT_TYPE_APP_JSON,
  CONTENT_TYPE_TEXT_VTT,
  CONTENT_TYPE_TEXT_XML,
  CONTENT_TYPE_APP_XML,
  CONTENT_ESTATUS_200,
  CONTENT_TYPE_APPLICATION_OCTET_STREAM
} from "./RequestManagerConstants";
import Utils from "../utils/Utils";
import AAFPlayer from "src/AAFPlayer/AAFPlayer";
import { refreshToken } from "./loader";

let counter = 0;

const addCounter = async function(request, error) {
  counter++;
  //TODO: saber si refreshtoken hara reintentos, para modificar la comparacion
  if(counter < 2) {
    try {
      await refreshToken();
    } catch(err) {
      return await addCounter(request, err);
    }
    try{
      let result =  await RequestManager.addRequest(request);
      cleanCounter();
      return result
    } catch(error) {
      cleanCounter();
      throw error;
    }

  } else {
    cleanCounter();
    throw request.parseErrors(error.response) || error;
  }
}

const cleanCounter = function() {
  counter = 0;
}
class RequestManager {
  static showModalRetryRequest(request, isUnsupportedProvider = false) {
    return new Promise((resolve, reject) => {
      const handleRetry = async () => {
        if (!isUnsupportedProvider) {
          request.getRetriesNumber = () => 0;
          resolve(this.addRequest(request));
        }
      };
      const handleReject = () => {
        reject("Can not get request");
      };
      if(request.getUrl().indexOf('/player')!==-1){
        //si falla apis de reproduccion se reinicia las tryingToPlayOptions
        AAFPlayer.setTryingToPlayOptions(null);
      }
      request.showModalRetry(handleRetry, handleReject, isUnsupportedProvider);
    });
  }

  static async getResponse(result, options){
    let response = null, contentType;
    if (
      result &&
      result.headers &&
      result.headers.get('content-type') !== ''
    ) {
      contentType = result.headers.get('content-type').toLowerCase();
      if (
        contentType.indexOf(CONTENT_TYPE_TEXT_HTML) !== -1 ||
        contentType.indexOf(CONTENT_TYPE_TEXT_PLAIN) !== -1 ||
        contentType.indexOf(CONTENT_TYPE_TEXT_VTT) !== -1 ||
        contentType.indexOf(CONTENT_TYPE_TEXT_XML) !== -1 ||
        contentType.indexOf(CONTENT_TYPE_APP_XML) !== -1
      ) {
        response = await result.body.asText();
      }
      else if(contentType.indexOf(CONTENT_TYPE_APPLICATION_OCTET_STREAM) !== -1){
        response= await result.body.asArrayBuffer();
      }
      else if (
        contentType.indexOf(CONTENT_TYPE_TEXT_JSON) !== -1 ||
        contentType.indexOf(CONTENT_TYPE_APP_JSON) !== -1
      ) {
        response = await result.body.asJSON();
      } else {
        response = await result.body.asJSON();
      }
    }else{
      if(options && options.isVtt){
        response = await result.body.asText();
      }
    }
    return response;
  }

  /**
   * [addRequest send request]
   * @type AbstractRequestTask request
   * @return Promise
   */
  static async addRequest(request) {
    if (!request) {
      throw new Error("request object is required");
    }
    const xhrClient = new XhrClient();
    let rurl = request.getUrl();

    if(rurl.substring(0, 4) !== 'http') {
      rurl = (window.location && window.location.protocol) ? window.location.protocol + '//' + rurl : 'http://' + rurl ;
    }

    const options = {
      method: request.getMethod() || GET,
      url: request.replaceProtocol(rurl),
      retries: request.getRetriesNumber(),
      headers: request.getHeaders(),
      statusCode400As200: request.getStatusCode400As200(),
      statusCode401As200: request.getStatusCode401As200(),
      statusCode409As200: request.getStatusCode409As200(),
      statusCode422As200: request.getStatusCode422As200(),
      statusCode304As200: request.getStatusCode304As200(),
      statusCode429As200: request.getStatusCode429As200(),
      statusCode404As200: request.getStatusCode404As200(),
      statusCode402As200: request.getStatusCode402As200(),
      statusCode500As200: request.getStatusCode500As200(),
      statusCode501As200: request.getStatusCode501As200(),
      overwriteHttps: request.getIsByHttps(),
      responseType: request.getResponseType(),
      isVtt: request && (typeof  request.getIsVTT === 'function') && request.getIsVTT() || false
    };

    const paramsUpdate = request.getParams();
    const isUrlWithVersion = /\/v\d+\//.test(rurl);
        const isBlackList = (
                          rurl.includes("services/user/v1/isloggedin") ||
                          rurl.includes("services/user/v1/authdevice")
                        );

    if(isBlackList || !isUrlWithVersion) delete paramsUpdate.user_token;

    switch (options.method) {
      case POST:
      case PUT:
        switch (request.getEncType()) {
          case "multipart/form-data":
            const params = paramsUpdate;
            const formDataParams = new FormData();
            for (const key in params) {
              formDataParams.append(key, params[key]);
            }
            options.body = formDataParams;
            break;
          case "application/json":
            options.body = JSON.stringify(paramsUpdate);
            break;
          default:
            options.body = Utils.buildQueryParams(paramsUpdate);
        }
        break;
      case HEAD:
        delete options.query;
        break;
      case GET:
      default:
        options.query = paramsUpdate;
    }

    return xhrClient
      .request(options)
      .then(async (result) => {
        const response = await this.getResponse(result, options);
        const status = result.status;
        if (request.isValid(response)) {
          if (response.data) {
            // Flujo para las apis versionadas que ya viene solo con data,
            // esto es para adecuar a la estrUctura actual soportada con response
            response.response = response.data;
            response.status = status;
          }
          return response;
        } else {
          let error = new Error();
          error = {response,status};
          if (Utils.isUnsupportedProvider(response)) error.isUnsupportedProvider = true;
          throw error
        }
      })
      .catch(async (error) => {
        if ((request.getShowErrorModal() && error.status && error.status!== CONTENT_ESTATUS_200) || error.isUnsupportedProvider) {
          const isUnsupportedProvider = error.isUnsupportedProvider || false;
          return this.showModalRetryRequest(request, isUnsupportedProvider);
        } else {
          if (error.response && error.response.data && (typeof error.response.data.asJSON === 'function')) {
            error = await error.response.data.asJSON();
          }
          if (error.entry) {
            error.entry.url = options.url;
          }

          if (error && error.response && error.response.errors) {
            const {response: { errors }} = error;
            const error401 = errors[0] ? errors[0].code : errors.code;
            if (error401 === 'USR_JWT_00002') {
              if(!(options.url.includes("loginbytoken") || options.url.includes("refresh_token"))) {
                return addCounter(request, error);
              }
            }
          }
          throw request.parseErrors(error.response) || error;
        }
      });
  }
}

export default RequestManager;



// WEBPACK FOOTER //
// ./src/requests/RequestManager.js